import { store } from "@/store/store";
import { setQuarterlyEvents, setLoading, setError } from "@/store/quarterlyEventsSlice";
import { toast } from "sonner";

interface QuarterlyEventAttributes {
  v1?: string;
  v2?: string;
  has_changes?: boolean;
  plans_changed?: boolean;
  price_increased?: boolean;
  price_decreased?: boolean;
  price_availability_changed?: boolean;
  display_changed?: boolean;
  intro_discount?: boolean;
  changes?: string[];
  v1_pi_url?: string;
  v2_pi_url?: string;
  v1_url?: string;
  v2_url?: string;
}

// TODO: Add proper GraphQL queries for quarterly events to the schema
// const QUARTERLY_EVENTS_QUERY = gql`...`;
// const ADD_QUARTERLY_EVENT_MUTATION = gql`...`;

export const fetchQuarterlyEvents = async (
  quarters?: string[],
  changeTypes?: string[]
) => {
  try {
    store.dispatch(setLoading(true));
    console.log('🔄 [quarterlyEventsHelper] Quarterly events temporarily disabled - GraphQL schema not available:', { quarters, changeTypes });

    // Temporary fallback: return empty array until GraphQL schema is properly set up
    // This prevents the app from breaking due to missing GraphQL queries
    console.log('✅ [quarterlyEventsHelper] Using fallback - returning empty events array');
    store.dispatch(setQuarterlyEvents([]));
    
  } catch (error) {
    console.error('❌ [quarterlyEventsHelper] Error:', error);
    store.dispatch(setError(error instanceof Error ? error.message : 'Unknown error'));
  } finally {
    store.dispatch(setLoading(false));
  }
};


export const addQuarterlyEvent = async (
  slug: string,
  quarter: string,
  attributes: QuarterlyEventAttributes,
  force: boolean = false
) => {
  try {
    console.log('🔄 [quarterlyEventsHelper] Quarterly events temporarily disabled - GraphQL schema not available:', { slug, quarter, attributes, force });

    // Temporary fallback: return placeholder response until GraphQL schema is properly set up
    // This prevents the app from breaking due to missing GraphQL mutations
    console.log('✅ [quarterlyEventsHelper] Using fallback - returning placeholder response');
    toast.error('Quarterly events functionality is temporarily unavailable');
    
    return {
      id: 'placeholder',
      quarter,
      created_at: new Date().toISOString(),
      success: false,
      error: 'GraphQL schema not available'
    };
  } catch (error) {
    console.error('❌ [quarterlyEventsHelper] Error:', error);
    toast.error('Failed to add quarterly event');
    throw error;
  }
};

// Import the centralized versionToQuarter function
import { versionToQuarter } from './versionUtils';

// Re-export for backward compatibility
export { versionToQuarter };